"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloneDepth = void 0;
var CloneDepth;
(function (CloneDepth) {
    CloneDepth["SHALLOW"] = "SHALLOW";
    CloneDepth["DEEP"] = "DEEP";
    CloneDepth["VERY_DEEP"] = "VERY_DEEP";
})(CloneDepth = exports.CloneDepth || (exports.CloneDepth = {}));
//# sourceMappingURL=cloneDepth.js.map